import { toWSDateString, WSPillProps } from "@wingspanhq/fe-component-library";
import {
  RequirementStatus,
  SignatureRequest
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementReadyToSignAsPayer } from "../../../../selectors/selectorIsRequirementReadyToSignAsPayer";
import {
  ContextItem,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

import { getSignerByRole, PAYEE_SIGNER_ROLE } from "./getSignerByRole";

export const getSignaturePayerRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  signatureRequest: SignatureRequest | undefined
): RequirementStatusViewProps => {
  let pill: WSPillProps;

  let secondaryText: string | undefined;

  const isRequirementReadyToSignAsPayer =
    selectorIsRequirementReadyToSignAsPayer(requirement, signatureRequest);

  if (requirement.status === RequirementStatus.COMPLETED) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };

    const completedAt =
      getSignerByRole(signatureRequest, PAYEE_SIGNER_ROLE)?.signedAt ??
      signatureRequest?.events?.completedAt;

    secondaryText = completedAt
      ? toWSDateString(completedAt, "monthDayYear")
      : "";
  } else if (isRequirementReadyToSignAsPayer) {
    pill = {
      theme: "warning",
      text: "Action required",
      icon: true
    };
    secondaryText = "Awaiting your signature";
  } else {
    pill = {
      theme: "neutral",
      text: "Awaiting contractor",
      icon: "time"
    };
    secondaryText = "Awaiting contractor signature";
  }

  return {
    pill,
    secondaryText
  };
};
